// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a8f2d76d-edc2-440c-8854-88a555760dd6',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '8af4a5ca-fbd3-4152-b83d-c8735761cc4c',
      type: 'Sprite',
      name: 'pigShadow',
      className: '',
      x: -7,
      y: 167,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.517241,
        y: 0.844828
      },
      angle: 0,
      alpha: 0.4,
      visible: true,
      tint: 16412534,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'a8f2d76d-edc2-440c-8854-88a555760dd6',
      stateByName: {
        Silver: {
          tint: '0x7dc0ff'
        },
        Gold: {
          tint: '0xfadc6f'
        },
        Opal: {
          tint: '0x6ffaf8'
        },
        Diamond: {
          tint: '0x6f9dfa'
        }
      }
    },
    {
      id: '555873c6-39ba-4979-949d-e8033dda09a5',
      type: 'Container',
      name: 'pigContainer',
      className: '',
      x: -21,
      y: 28,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a8f2d76d-edc2-440c-8854-88a555760dd6'
    },
    {
      id: '59e576e2-f18c-4b17-b2b3-d6056f94ee5e',
      type: 'Sprite',
      name: 'pigSprite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '555873c6-39ba-4979-949d-e8033dda09a5',
      stateByName: {
        claimable: {
          visible: false
        },
        inClaimAnimation: {
          visible: false
        },
        Silver: {
          texture: 'Piggy_Bank_Normal_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Normal_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Normal_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Normal_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Normal'
        },
        Normal: {
          texture: 'Piggy_Bank_Normal'
        }
      }
    },
    {
      id: 'daa48269-a819-4b8e-bc00-93ed80f85474',
      type: 'Sprite',
      name: 'pigFullSprite',
      className: '',
      x: -2,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '555873c6-39ba-4979-949d-e8033dda09a5',
      stateByName: {
        claimable: {
          visible: true
        },
        unclaimable: {
          visible: false
        },
        inClaimAnimation: {
          visible: true
        },
        Silver: {
          texture: 'Piggy_Bank_Happy_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Happy_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Happy_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Happy_Diamond'
        },
        Normal: {
          texture: 'Piggy_Bank_Happy'
        },
        Legacy: {
          texture: 'Piggy_Bank_Happy'
        }
      }
    },
    {
      id: '5dfb82a2-0992-488e-9a44-94e0cc9a0c73',
      type: 'Sprite',
      name: 'pigGlowSprite',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Glow',
      parent: '555873c6-39ba-4979-949d-e8033dda09a5',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Glow',
          visible: false
        },
        Gold: {
          texture: 'Piggy_Bank_Glow'
        }
      }
    },
    {
      id: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      type: 'Container',
      name: 'pigPieces',
      className: '',
      x: 54,
      y: -22,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '555873c6-39ba-4979-949d-e8033dda09a5',
      stateByName: {
        claimable: {
          visible: false
        }
      }
    },
    {
      id: '190477ae-627a-449b-ba66-f4e2edea475a',
      type: 'Sprite',
      name: 'pigCracks',
      className: '',
      x: 5,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Cracks',
      parent: '555873c6-39ba-4979-949d-e8033dda09a5'
    },
    {
      id: '95017dc1-829d-477b-a6f3-c3f4345d9f6a',
      type: 'Graphics',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '555873c6-39ba-4979-949d-e8033dda09a5',
      commands: [
        {
          id: '4cb79f3b-cc08-461b-b949-806ad3cad4f0',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: 'cff8a873-632d-489e-9ca6-170ab7a15be0',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: '0b12f63c-0197-48bc-a8a5-9481079bcb9d',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        }
      ]
    },
    {
      id: '8be47ee3-209a-4645-b622-682bb82e76f0',
      type: 'Container',
      name: 'fillCoinAnimation',
      className: '',
      x: 67,
      y: -66,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '555873c6-39ba-4979-949d-e8033dda09a5'
    },
    {
      id: '96eaf3ad-1a57-4f2d-895c-80ebfeabef41',
      type: 'Sprite',
      name: 'pigPiece1',
      className: '',
      x: -154,
      y: -72,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_1_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_1_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_1_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_1_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_1'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_1'
        }
      }
    },
    {
      id: '8c68e7fa-5e62-4ad7-baaa-4ce58cbcc022',
      type: 'Sprite',
      name: 'pigPiece2',
      className: '',
      x: -40,
      y: -124,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_2_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_2_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_2_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_2_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_2'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_2'
        }
      }
    },
    {
      id: 'b8501338-364d-4e0b-87d0-e944f5121cdf',
      type: 'Sprite',
      name: 'pigPiece3',
      className: '',
      x: 86,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_3_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_3_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_3_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_3_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_3'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_3'
        }
      }
    },
    {
      id: '5a312d30-343b-48ed-8c85-b3e15c047a33',
      type: 'Sprite',
      name: 'pigPiece4',
      className: '',
      x: -133,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_4_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_4_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_4_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_4_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_4'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_4'
        }
      }
    },
    {
      id: 'd948e400-cda0-4ff6-94d7-45151c6dbbed',
      type: 'Sprite',
      name: 'pigPiece5',
      className: '',
      x: -21,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_5_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_5_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_5_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_5_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_5'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_5'
        }
      }
    },
    {
      id: '1ba35cd7-5255-4245-910d-e9cc6ceaf1d7',
      type: 'Sprite',
      name: 'pigPiece6',
      className: '',
      x: -197,
      y: 66,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_6_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_6_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_6_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_6_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_6'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_6'
        }
      }
    },
    {
      id: '241845b8-76ee-4a6f-b536-bad7c9d47df9',
      type: 'Sprite',
      name: 'pigPiece7',
      className: '',
      x: -140,
      y: 83,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_7_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_7_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_7_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_7_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_7'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_7'
        }
      }
    },
    {
      id: '08944ef4-696b-46f4-bb51-2878508eab04',
      type: 'Sprite',
      name: 'pigPiece8',
      className: '',
      x: 1,
      y: 72,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_8_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_8_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_8_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_8_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_8'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_8'
        }
      }
    },
    {
      id: '133a896d-872d-4606-af95-c65a63cb97d5',
      type: 'Sprite',
      name: 'pigPiece9',
      className: '',
      x: 87,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_9_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_9_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_9_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_9_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_9'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_9'
        }
      }
    },
    {
      id: '1821b8d8-e859-4eac-a6a1-6ac0657c5a24',
      type: 'Sprite',
      name: 'pigPiece10',
      className: '',
      x: -145,
      y: 156,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_10_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_10_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_10_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_10_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_10'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_10'
        }
      }
    },
    {
      id: 'b6e58a81-0c3d-4113-a6a2-faec9bbe4422',
      type: 'Sprite',
      name: 'pigPiece11',
      className: '',
      x: -49,
      y: 148,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_11_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_11_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_11_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_11_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_11'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_11'
        }
      }
    },
    {
      id: 'd5ac4808-3496-44dd-9b17-4585cf6365b2',
      type: 'Sprite',
      name: 'pigPiece12',
      className: '',
      x: 81,
      y: 83,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '683b67aa-063a-4ce7-aecd-a1ca6654e178',
      stateByName: {
        Silver: {
          texture: 'Piggy_Bank_Piece_12_Silver'
        },
        Gold: {
          texture: 'Piggy_Bank_Piece_12_Gold'
        },
        Opal: {
          texture: 'Piggy_Bank_Piece_12_Opal'
        },
        Diamond: {
          texture: 'Piggy_Bank_Piece_12_Diamond'
        },
        Legacy: {
          texture: 'Piggy_Bank_Piece_12'
        },
        Normal: {
          texture: 'Piggy_Bank_Piece_12'
        }
      }
    },
    {
      id: '1cd99ba7-eade-44aa-9af0-1de3e4ba34db',
      type: 'Sprite',
      name: 'fillCoinMask',
      className: '',
      x: -244,
      y: -278,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Coin_Mask',
      parent: '8be47ee3-209a-4645-b622-682bb82e76f0'
    },
    {
      id: 'acbaa5c9-8212-4047-8c99-eee5ed2f7f31',
      type: 'Sprite',
      name: 'fillCoin',
      className: '',
      x: -125,
      y: -227,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Icon',
      parent: '8be47ee3-209a-4645-b622-682bb82e76f0'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'Silver',
    'Gold',
    'Opal',
    'Diamond',
    'Normal',
    'Legacy'
  ],
  handleResize: false
} as const;

export class PiggyBankLayout {
  static raw = raw;
  root!: Container;
  pigShadow!: Sprite;
  pigContainer!: Container;
  pigSprite!: Sprite;
  pigFullSprite!: Sprite;
  pigGlowSprite!: Sprite;
  pigPieces!: Container;
  pigCracks!: Sprite;
  fillCoinAnimation!: Container;
  pigPiece1!: Sprite;
  pigPiece2!: Sprite;
  pigPiece3!: Sprite;
  pigPiece4!: Sprite;
  pigPiece5!: Sprite;
  pigPiece6!: Sprite;
  pigPiece7!: Sprite;
  pigPiece8!: Sprite;
  pigPiece9!: Sprite;
  pigPiece10!: Sprite;
  pigPiece11!: Sprite;
  pigPiece12!: Sprite;
  fillCoinMask!: Sprite;
  fillCoin!: Sprite;
  StateName!: 'Silver' | 'Gold' | 'Opal' | 'Diamond' | 'Normal' | 'Legacy';

  constructor() {
    populate(this, raw);
  }
}
